import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { HomeService } from 'src/app/home/services/home.service';

@Component({
  selector: 'app-desktop-devices-modal',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './desktop-devices-modal.component.html',
  styleUrls: ['./desktop-devices-modal.component.scss', '../../../../app.component.scss']
})
export class DesktopDevicesModalComponent {
  public errorMessage: string = "";

  public desktop = {
    desktop_id: "",
    type: "",
    name: "",
  };

  constructor(
    public dialogRef: MatDialogRef<DesktopDevicesModalComponent>,
    private homeService: HomeService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data) {
      this.desktop.desktop_id = data.device_id;
      this.desktop.type = data.type;
      this.desktop.name = data.name;
    }
  }

  editDesktop() {
    this.homeService.editDesktop(this.desktop.desktop_id, { u_name: this.desktop.name }).subscribe({
      next: (res) => {
        if (res.data) {
          this.dialogRef.close(res.data.u_name);  // Close the dialog with the updated u_name
        }
      },
      error: (err) => {
        this.errorMessage = this.desktop.type === 'u_name'
          ? "The given desktop name has already been taken."
          : "An error occurred while updating the desktop.";
      }
    });
  }


  
  // save(): void {
  //   this.dialogRef.close({ device_id: this.data.device_id, updatedData: this.data });
  // }

  onClose(): void {
    this.dialogRef.close();
  }
}
